"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeMediaType = exports.OfficeObjectStatus = void 0;
var OfficeObjectStatus;
(function (OfficeObjectStatus) {
    OfficeObjectStatus[OfficeObjectStatus["ON"] = 9] = "ON";
    OfficeObjectStatus[OfficeObjectStatus["OFF"] = 10] = "OFF";
})(OfficeObjectStatus = exports.OfficeObjectStatus || (exports.OfficeObjectStatus = {}));
var OfficeMediaType;
(function (OfficeMediaType) {
    OfficeMediaType[OfficeMediaType["FORM"] = 1] = "FORM";
    OfficeMediaType[OfficeMediaType["PHONE"] = 3] = "PHONE";
    OfficeMediaType[OfficeMediaType["WHATSAPP"] = 4] = "WHATSAPP";
})(OfficeMediaType = exports.OfficeMediaType || (exports.OfficeMediaType = {}));
